import z from 'zod';

import { CharacteristicSchema } from './Characteristic';
import { Characteristic } from './Characteristic';
import { SaveCarbonDioxideDtoSchema } from './SaveCarbonDioxideDto';
import { SaveCarbonDioxideDto } from './SaveCarbonDioxideDto';
import { SynonymDtoSchema } from './SynonymDto';
import { SynonymDto } from './SynonymDto';

export type SaveAccessoryRequestModel = {
	price: number | null;
	isPriceRecipeRelevant: boolean;
	characteristic: Characteristic | null;
	density: number | null;
	imageId: string | null;
	nameSingularTranslations: { [key: string]: string };
	namePluralTranslations: { [key: string]: string };
	unitWeights: { [key: string]: number };
	categories: string[];
	tags: string[];
	carbonDioxide: SaveCarbonDioxideDto[];
	synonyms: { [key: string]: SynonymDto[] };
	currencyCode: string | null;
};

export const SaveAccessoryRequestModelSchema: z.ZodType<SaveAccessoryRequestModel> = z.object({
	price: z.number().nullable(),
	isPriceRecipeRelevant: z.boolean(),
	characteristic: z.lazy(() => CharacteristicSchema).nullable(),
	density: z.number().nullable(),
	imageId: z.string().nullable(),
	nameSingularTranslations: z.record(z.string()),
	namePluralTranslations: z.record(z.string()),
	unitWeights: z.record(z.number()),
	categories: z.string().array(),
	tags: z.string().array(),
	carbonDioxide: z.lazy(() => SaveCarbonDioxideDtoSchema).array(),
	synonyms: z.record(z.array(z.lazy(() => SynonymDtoSchema))),
	currencyCode: z.string().nullable(),
});
